import { logger } from '../index';

export const formatNumberByLocale = (numb: number | string, lang: string): string => {
  const { log } = logger({})('formatNumberByLocale');
  log.debug(
    `[PerfTesting][utils] Entering the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  );
  const inputStr = numb ?? '';
  // convert input number to locale string according to the lang
  // const str = Number(inputStr).toLocaleString(lang || '');
  let str = '';
  switch (lang) {
    case 'ko-KR':
    case 'ja-JP':
    case 'it-IT':
    case 'fr-FR':
    case 'de-DE':
    case 'ru-RU':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2 });
      break;
    case 'pt-BR':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 3 });
      break;
    case 'es-ES':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2, useGrouping: true });
      break;
    case '':
    case undefined:
      str = Number(inputStr)?.toLocaleString();
      break;
    default:
      str = Number(inputStr)?.toLocaleString(lang || '');
      break;
  }
  log.debug(
    `[PerfTesting][utils] Exiting the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  );
  return str;
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const getCtaUrl = (node: any, currentLocale?: string) => {
  const seoNickname = node?.seoNickname || node?.property?.seoNickname;
  const subDirectoryVal = currentLocale?.toLowerCase();
  return `/${subDirectoryVal}/hotels/${seoNickname}/overview/`;
};

const rules: Record<string, string> = {
  ACTIVITIES: 'activities-on-site',
  AMENITIES: 'amenities',
  PROPERTY_TYPES: 'property-types',
  BRANDS: 'brands',
};

const buildViewAllUrl = (obj?: Record<string, string[]>): string => {
  if (!obj) return '';

  const params = new URLSearchParams();
  Object.entries(obj).forEach(([key, values]) => {
    if (Array.isArray(values) && values.length > 0) {
      const rule = rules[key];
      const value = values.join(',').toLowerCase();

      const finalKey = rule ?? key;
      params.append(finalKey, value);
    }
  });

  return params.toString();
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const getViewAllUrl = (searchCriteria: any, currentLocale?: string) => {
  const urlStr = buildViewAllUrl(searchCriteria);
  const subDirectoryVal = currentLocale?.toLowerCase();
  const decodeURIStr = decodeURIComponent(urlStr);
  return `/${subDirectoryVal}/hotel-search.mi?filtersApplied=true&${decodeURIStr}`;
};
